import React from 'react';
import { FooterWrapper } from './styled';

const Footer = () => (
  <FooterWrapper>
    Desarrollado por @
    <a
      href="https://github.com/JuanPablo-Hack"
      target="_blank"
      rel="noreferrer noopener"
    >
      JuanPablo-Hack
    </a>
  </FooterWrapper>
);

export default Footer;
